var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { class: { disabled: _vm.disabled }, attrs: { href: _vm.url } },
    [
      _c("i", { staticClass: "fas fa-project-diagram" }),
      _vm._v(
        " " +
          _vm._s(
            _vm.resource("JourneyComposer_Overview_JourneyReport_Button")
          ) +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }